<template>
  <div class="mt-2">
    <div style="margin-bottom: 35px;">
      <div class="intent-item z-border-red">
        <form>
          <template v-for="(item, index) in data">
            <div :key="`close${index}`" class="text-xs-right">
              <v-btn flat small fab @click="deleteSubBooking(item)">
                <v-icon>
                  close
                </v-icon>
              </v-btn>
            </div>
            <v-layout wrap :key="index" style="padding: 10px 15px 0px;">
              <v-flex xs12 sm6>
                <div
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has(`name_${index}`) }"
                >
                  <label>{{ $t('name') }}</label>
                  <input
                    :data-vv-as="$t('name')"
                    v-model="item.sub_booking_name"
                    :name="`name_${index}`"
                    class="form-control mr-3"
                    type="text"
                    v-validate="'required'"
                  />
                  <span class="text-error" v-if="errors.has(`name_${index}`)">{{
                    errors.first(`name_${index}`)
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has(`max_available_slot_${index}`) }"
                >
                  <label>{{ $t('bookings_per_time') }}</label>
                  <input
                    :data-vv-as="$t('bookings_per_time')"
                    v-model="item.max_available_slot"
                    :name="`max_available_slot_${index}`"
                    v-validate="'required'"
                    class="form-control mr-3"
                    type="number"
                  />
                  <span class="text-error" v-if="errors.has(`max_available_slot_${index}`)">{{
                    errors.first(`max_available_slot_${index}`)
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has(`startAtDate${index}`) }"
                >
                  <label class="mr-3">{{ $t('start_date_booking') }}</label>
                  <v-menu
                    :ref="`openStartDate_${index}`"
                    :key="`openStartDate_${index}`"
                    v-model="item.openStartDate"
                    :close-on-content-click="false"
                    full-width
                    max-width="290px"
                    color="primary"
                  >
                    <template v-slot:activator="{ on }">
                      <input
                        :key="`openStartDate_${index}`"
                        type="text"
                        class="form-control browser-default"
                        :placeholder="$t('Date')"
                        readonly
                        v-model="item.startAtDate"
                        v-on="on"
                        v-validate="'required'"
                        clearable
                        small
                        :name="`startAtDate${index}`"
                      />
                    </template>
                    <v-date-picker
                      :key="`openStartDate_${index}`"
                      :allowed-dates="allowedDates"
                      color="primary"
                      v-model="item.startAtDate"
                      @input="item.openStartDate = false"
                    ></v-date-picker>
                  </v-menu>
                  <span class="text-error" v-if="errors.has('startAtDate')">{{
                    errors.first('startAtDate')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="pa-1">
                  <span class="mr-2 ml-2" style="align-self: center;">{{ $t('time_starts') }}</span>
                  <time-picker
                    color="primary"
                    v-model="item.startAtTime"
                    hide-disabled-minutes
                    :placeholder="$t('time')"
                    format="HH:mm"
                    full-width
                  ></time-picker>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has(`endAtDate_${index}`) }"
                >
                  <label class="mr-3">{{ $t('end_date_booking') }}</label>

                  <v-menu
                    :ref="`openEndDate_${index}`"
                    :key="`openEndDate_${index}`"
                    v-model="item.openEndDate"
                    :close-on-content-click="false"
                    full-width
                    max-width="290px"
                    color="primary"
                  >
                    <template v-slot:activator="{ on }">
                      <input
                        :key="`openEndDate_${index}`"
                        type="text"
                        class="form-control browser-default"
                        :placeholder="$t('Date')"
                        readonly
                        v-model="item.endAtDate"
                        v-on="on"
                        v-validate="'required'"
                        clearable
                        small
                        :name="`endAtDate_${index}`"
                      />
                    </template>
                    <v-date-picker
                      :key="`openEndDate_${index}`"
                      :allowed-dates="allowedDates"
                      color="primary"
                      v-model="item.endAtDate"
                      @input="item.openEndDate = false"
                    ></v-date-picker>
                  </v-menu>
                  <span class="text-error" v-if="errors.has('endAtDate')">{{
                    errors.first('endAtDate')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="pa-1">
                  <span class="mr-2 ml-2" style="align-self: center;">{{ $t('time_ends') }}</span>
                  <time-picker
                    color="primary"
                    v-model="item.endAtTime"
                    hide-disabled-minutes
                    :placeholder="$t('time')"
                    format="HH:mm"
                    full-width
                  ></time-picker>
                </div>
              </v-flex>
            </v-layout>
            <div
              :key="`line_${index}`"
              style="border-bottom: 1px red solid; margin-bottom: 25px; margin-top: 25px"
            ></div>
          </template>
          <a href="javascript:void(0);" @click="addSlot">
            <div class="add-conversation text-xs-center">
              <i class="fa fa-plus middle"></i>
              {{ $t('add_slot') }}
            </div>
          </a>

          <div class="text-xs-center">
            <small style="color: red" v-if="errorDateTime">{{
              $t('please_enter_end_date_than_starting_date')
            }}</small>
          </div>

          <div class="text-xs-center mt-3">
            <v-btn outline color="grey" :loading="loading" @click="closeEdit">{{
              $t('cancel')
            }}</v-btn>
            <v-btn depressed color="primary" :loading="loading" @click="submitFrom">{{
              $t('Save')
            }}</v-btn>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TimePicker from '@/components/elements/TimePicker.vue'
import dayjs from 'dayjs'
export default {
  props: ['value', 'isEditDialog', 'isEdit', 'errorDateTime', 'loading'],
  data() {
    return {
      data: this.value
    }
  },
  components: { TimePicker },
  mounted() {
    const vm = this
    if (vm.data.length > 0) {
      vm.data.map(item => {
        item.openEndDate = false
        item.openStartDate = false
      })
    }
  },
  methods: {
    deleteSubBooking(param) {
      const vm = this
      vm.data = vm.data.filter(item => item !== param)
    },
    addSlot() {
      const vm = this
      vm.data.push({
        startAtTime: { HH: '00', mm: '00' },
        endAtTime: { HH: '00', mm: '00' },
        startAtDate: dayjs().format('YYYY-MM-DD'),
        endAtDate: dayjs().format('YYYY-MM-DD')
      })
    },
    closeEdit() {
      const vm = this
      vm.$emit('update:isEditDialog', false)
    },
    async submitFrom() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        vm.$emit('input', vm.data)
        vm.$emit('saveSubBookingCommon')
      }
    },
    allowedDates(val) {
      return dayjs().diff(val, 'days') < 1
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/intent/calendar/SubBookingForm.vue